<template>
  <div>
    <editor-menu-bar v-slot="{ commands, isActive }" :editor="editor">
      <v-container>
        <v-row>
          <v-tooltip bottom dark>
            <template v-slot:activator="{ on }">
              <v-btn
                fab
                :outlined="!isActive.bold()"
                x-small
                color="primary"
                class="mr-2"
                v-on="on"
                @click="commands.bold"
                ><v-icon>mdi-format-bold</v-icon></v-btn
              >
            </template>
            <span>Pogrubienie</span>
          </v-tooltip>

          <v-tooltip bottom dark>
            <template v-slot:activator="{ on }">
              <v-btn
                fab
                :outlined="!isActive.italic()"
                x-small
                color="primary"
                class="mr-2"
                v-on="on"
                @click="commands.italic"
              >
                <v-icon>mdi-format-italic</v-icon>
              </v-btn>
            </template>
            <span>Kursywa</span>
          </v-tooltip>

          <v-tooltip bottom dark>
            <template v-slot:activator="{ on }">
              <v-btn
                fab
                :outlined="!isActive.underline()"
                x-small
                color="primary"
                class="mr-2"
                v-on="on"
                @click="commands.underline"
              >
                <v-icon>mdi-format-underline</v-icon>
              </v-btn>
            </template>
            <span>Podkreślenie</span>
          </v-tooltip>

          <v-tooltip bottom dark>
            <template v-slot:activator="{ on }">
              <v-btn
                fab
                :outlined="!isActive.strike()"
                x-small
                color="primary"
                class="mr-2"
                v-on="on"
                @click="commands.strike"
              >
                <v-icon>mdi-format-strikethrough</v-icon>
              </v-btn>
            </template>
            <span>Przekreślenie</span>
          </v-tooltip>

          <v-tooltip bottom dark>
            <template v-slot:activator="{ on }">
              <v-btn
                fab
                :outlined="!isActive.code()"
                x-small
                color="primary"
                class="mr-2"
                v-on="on"
                @click="commands.code"
              >
                <v-icon>mdi-code-tags</v-icon>
              </v-btn>
            </template>
            <span>Kod</span>
          </v-tooltip>

          <v-spacer />

          <v-tooltip bottom dark>
            <template v-slot:activator="{ on }">
              <v-btn
                fab
                :outlined="!isActive.paragraph()"
                x-small
                color="primary"
                class="mr-2"
                v-on="on"
                @click="commands.paragraph"
              >
                <v-icon>mdi-format-paragraph</v-icon>
              </v-btn>
            </template>
            <span>Normalny</span>
          </v-tooltip>

          <v-tooltip bottom dark>
            <template v-slot:activator="{ on }">
              <v-btn
                fab
                :outlined="!isActive.heading({ level: 1 })"
                x-small
                color="primary"
                class="mr-2"
                v-on="on"
                @click="commands.heading({ level: 1 })"
              >
                <v-icon>mdi-format-header-1</v-icon>
              </v-btn>
            </template>
            <span>Nagłówek 1</span>
          </v-tooltip>

          <v-tooltip bottom dark>
            <template v-slot:activator="{ on }">
              <v-btn
                fab
                :outlined="!isActive.heading({ level: 2 })"
                x-small
                color="primary"
                class="mr-2"
                v-on="on"
                @click="commands.heading({ level: 2 })"
              >
                <v-icon>mdi-format-header-2</v-icon>
              </v-btn>
            </template>
            <span>Nagłówek 2</span>
          </v-tooltip>

          <v-tooltip bottom dark>
            <template v-slot:activator="{ on }">
              <v-btn
                fab
                :outlined="!isActive.heading({ level: 3 })"
                x-small
                color="primary"
                class="mr-2"
                v-on="on"
                @click="commands.heading({ level: 3 })"
              >
                <v-icon>mdi-format-header-3</v-icon>
              </v-btn>
            </template>
            <span>Nagłówek 3</span>
          </v-tooltip>

          <v-spacer />

          <v-tooltip bottom dark>
            <template v-slot:activator="{ on }">
              <v-btn
                fab
                :outlined="true"
                x-small
                color="primary"
                class="mr-2"
                v-on="on"
                @click="commands.alignment({ textAlign: 'left' })"
                ><v-icon>mdi-format-align-left</v-icon></v-btn
              >
            </template>
            <span>Wyrównaj do lewej</span>
          </v-tooltip>

          <v-tooltip bottom dark>
            <template v-slot:activator="{ on }">
              <v-btn
                fab
                :outlined="true"
                x-small
                color="primary"
                class="mr-2"
                v-on="on"
                @click="commands.alignment({ textAlign: 'center' })"
                ><v-icon>mdi-format-align-center</v-icon></v-btn
              >
            </template>
            <span>Wyrównaj do prawej</span>
          </v-tooltip>

          <v-tooltip bottom dark>
            <template v-slot:activator="{ on }">
              <v-btn
                fab
                :outlined="true"
                x-small
                color="primary"
                class="mr-2"
                v-on="on"
                @click="commands.alignment({ textAlign: 'right' })"
                ><v-icon>mdi-format-align-right</v-icon></v-btn
              >
            </template>
            <span>Wyrównaj do środka</span>
          </v-tooltip>

          <v-tooltip bottom dark>
            <template v-slot:activator="{ on }">
              <v-btn
                fab
                :outlined="true"
                x-small
                color="primary"
                class="mr-2"
                v-on="on"
                @click="commands.alignment({ textAlign: 'justify' })"
                ><v-icon>mdi-format-align-justify</v-icon></v-btn
              >
            </template>
            <span>Wyjustuj</span>
          </v-tooltip>

          <v-spacer />

          <v-tooltip bottom dark>
            <template v-slot:activator="{ on }">
              <v-btn
                fab
                :outlined="!isActive.bullet_list()"
                x-small
                color="primary"
                class="mr-2"
                :disabled="isActive.code_block()"
                v-on="on"
                @click="commands.bullet_list"
              >
                <v-icon>mdi-format-list-bulleted-square</v-icon>
              </v-btn>
            </template>
            <span>Punktatory</span>
          </v-tooltip>

          <v-tooltip bottom dark>
            <template v-slot:activator="{ on }">
              <v-btn
                fab
                :outlined="!isActive.ordered_list()"
                x-small
                color="primary"
                class="mr-2"
                :disabled="isActive.code_block()"
                v-on="on"
                @click="commands.ordered_list"
              >
                <v-icon>mdi-format-list-numbered</v-icon>
              </v-btn>
            </template>
            <span>Numeracja</span>
          </v-tooltip>

          <v-spacer />

          <v-tooltip bottom dark>
            <template v-slot:activator="{ on }">
              <v-btn fab x-small color="primary" class="mr-2" v-on="on" @click="commands.undo">
                <v-icon>mdi-undo</v-icon>
              </v-btn>
            </template>
            <span>Cofnij</span>
          </v-tooltip>

          <v-tooltip bottom dark>
            <template v-slot:activator="{ on }">
              <v-btn fab x-small color="primary" class="mr-2" v-on="on" @click="commands.redo">
                <v-icon>mdi-redo</v-icon>
              </v-btn>
            </template>
            <span>Wykonaj ponownie</span>
          </v-tooltip>
        </v-row>
      </v-container>
    </editor-menu-bar>
    <v-card><editor-content class="text-lesson-edit__content pa-2" :editor="editor"/></v-card>
  </div>
</template>

<script>
import { Editor, EditorContent, EditorMenuBar } from 'tiptap';
import {
  Blockquote,
  CodeBlock,
  HardBreak,
  Heading,
  HorizontalRule,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  Link,
  Strike,
  Underline,
  History
} from 'tiptap-extensions';
import { Alignment } from '@/plugins/tiptap/extensions';

export default {
  components: {
    EditorContent,
    EditorMenuBar
  },
  props: {
    lesson: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      keepInBounds: true,
      editor: new Editor({
        extensions: [
          new Blockquote(),
          new BulletList(),
          new CodeBlock(),
          new HardBreak(),
          new Heading({ levels: [1, 2, 3] }),
          new HorizontalRule(),
          new ListItem(),
          new OrderedList(),
          new TodoItem(),
          new TodoList(),
          new Link(),
          new Bold(),
          new Code(),
          new Italic(),
          new Strike(),
          new Underline(),
          new History(),
          new Alignment()
        ],
        content: this.lesson.html,
        onUpdate: this.onChange
      })
    };
  },
  beforeDestroy() {
    this.editor.destroy();
  },
  methods: {
    onChange(ev) {
      this.$emit('change', { type: this.lesson.type, value: ev.getHTML() });
    }
  }
};
</script>

<style lang="scss">
.text-lesson-edit__content {
  p {
    margin-bottom: 0 !important;
  }

  h1 {
    font-size: 2rem;
  }
}
</style>
